// extracted by mini-css-extract-plugin
module.exports = {"ratingRow":"productRecommendation_ratingRow__nrbi3","ratingInner":"productRecommendation_ratingInner__kt9o7","count":"productRecommendation_count__gZAzE"};